import { useState } from "react";
import { Button, Box } from "@mui/material";
import PropTypes from "prop-types";
import "./reusable-tabs.css";

const ReusableTabs = ({ tabs, activeColor = "#E91D25", children }) => {
    const [activeTab, setActiveTab] = useState(tabs[0]?.value);

    return (
        <Box className="reusable-tabs-wrapper">
            <Box className="reusable-tabs-header">
                {tabs.map((tab) => (
                    <Button key={tab.value} className="reusable-tab-button" onClick={() => setActiveTab(tab.value)}>
                        <Box
                            className={`reusable-tab ${activeTab === tab.value ? "active" : ""}`}
                            style={{
                                color: activeTab === tab.value ? activeColor : "inherit",
                                borderBottom: activeTab === tab.value ? `4px solid ${activeColor}` : "none",
                            }}
                        >
                            {tab.label}
                        </Box>
                    </Button>
                ))}
            </Box>
            {/* <hr style={{ border: "1px solid #F0F0F0" }} /> */}

            <Box className="reusable-tabs-content">
                {tabs.map((tab) => activeTab === tab.value && <Box key={tab.value}>{tab.component}</Box>)}
            </Box>
        </Box>
    );
};

ReusableTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            component: PropTypes.node.isRequired,
        })
    ).isRequired,
    activeColor: PropTypes.string,
    children: PropTypes.node,
};

export default ReusableTabs;
